<template v-if="isVisible">
  <aside id="head_campaign">
      <div v-for="item in items" :key="item.id">
        <a :href="'/information/' + item.id">
          <div class="container">
            <h2>
              {{ item.title }}
            </h2>
          </div>
        </a>
      </div>

    <div class="spinner_pickup" v-if="isLoading">
      <pulse-loader
        :loading="isLoading"
        :color="'#f5f5f5'"
        :size="'10px'"
      ></pulse-loader>
    </div>
  </aside>
</template>

<script>
export default {
  name: "news-pickup-component",
  data() {
    return {
      items: [],
      isVisible: false,
      isLoading: false,
    };
  },
  props: {
    count: {
      type:Number,
      default: 1,
    }
  },
  methods: {
    getNewsPickup() {
      const apiUrl = "/information-pickup";
      this.isLoading = true;
      axios
        .get(apiUrl)
        .then((res) => {
          const newsPickup = res.data.information_pickup;
          this.items = newsPickup.slice(0, this.count);
          if (newsPickup != null) {
            this.isVisible = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getNewsPickup();
  },
};
</script>

<style lang="scss">
.spinner_pickup {
  padding: 12px;
  width: 100%;
  text-align: center;
  z-index: 10;
}
</style>
